import { motion } from "framer-motion";
import { scrollToId } from "@/data";

const letterBase =
  "relative inline-block font-display font-black uppercase leading-none tracking-tight select-none";

function TrumpHair() {
  return (
    <svg
      viewBox="0 0 100 42"
      aria-hidden="true"
      className="pointer-events-none absolute -top-[0.16em] left-1/2 w-[0.92em] -translate-x-1/2"
    >
      <path
        d="M3 36 Q 18 4 52 8 Q 84 11 97 3 Q 90 24 58 21 Q 26 18 3 36 Z"
        fill="#F6C85F"
        stroke="#B8860B"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <path
        d="M14 26 Q 34 10 62 12"
        fill="none"
        stroke="#B8860B"
        strokeWidth="2"
        strokeLinecap="round"
        opacity="0.7"
      />
    </svg>
  );
}

function CatEars() {
  return (
    <svg
      viewBox="0 0 100 52"
      aria-hidden="true"
      className="pointer-events-none absolute -top-[0.17em] left-1/2 w-[0.85em] -translate-x-1/2"
    >
      <path d="M8 50 L27 5 L50 46 Z" fill="#F97316" stroke="#B8860B" strokeWidth="2.5" strokeLinejoin="round" />
      <path d="M50 46 L73 5 L92 50 Z" fill="#F97316" stroke="#B8860B" strokeWidth="2.5" strokeLinejoin="round" />
      <path d="M20 42 L28 20 L39 40 Z" fill="#FDA4AF" />
      <path d="M61 40 L72 20 L80 42 Z" fill="#FDA4AF" />
    </svg>
  );
}

function Whiskers() {
  return (
    <svg
      viewBox="0 0 160 60"
      aria-hidden="true"
      className="pointer-events-none absolute left-1/2 top-[52%] w-[1.35em] -translate-x-1/2 -translate-y-1/2"
    >
      <g stroke="rgba(248,250,252,0.85)" strokeWidth="2.5" strokeLinecap="round">
        <line x1="4" y1="12" x2="42" y2="24" />
        <line x1="2" y1="30" x2="42" y2="31" />
        <line x1="4" y1="48" x2="42" y2="38" />
        <line x1="156" y1="12" x2="118" y2="24" />
        <line x1="158" y1="30" x2="118" y2="31" />
        <line x1="156" y1="48" x2="118" y2="38" />
      </g>
    </svg>
  );
}

export function TateLetters({ className = "", hoverLift = false }) {
  const lift = hoverLift
    ? "transition-transform duration-500 group-hover:-translate-y-[0.02em]"
    : "";
  return (
    <span className={`inline-flex items-start justify-center gap-[0.015em] ${className}`}>
      {/* $ — gold outline */}
      <span className={`${letterBase} text-stroke-gold transition-all duration-500 group-hover:[-webkit-text-stroke-color:#F6C85F]`}>
        $
      </span>
      {/* T — Trump: presidential navy, gold stroke, combover hair */}
      <span className={`${letterBase} text-[#16263F] [-webkit-text-stroke:2.5px_rgba(229,169,60,0.75)] transition-all duration-500 group-hover:[-webkit-text-stroke-color:#F6C85F]`}>
        <TrumpHair />
        T
      </span>
      {/* A — CATE: orange fur gradient + cat ears */}
      <span
        className={`${letterBase} bg-gradient-to-b from-[#F6C85F] to-[#F97316] bg-clip-text text-transparent ${lift}`}
      >
        <CatEars />
        A
      </span>
      {/* T — Trump: American flag fill (canton + stars + stripes) */}
      <span
        className={`${letterBase} bg-clip-text text-transparent [-webkit-text-stroke:1.5px_rgba(248,250,252,0.3)] ${lift}`}
        style={{
          backgroundImage: [
            "radial-gradient(circle at center, rgba(248,250,252,0.95) 1.2px, transparent 1.7px)",
            "linear-gradient(#14294D, #14294D)",
            "repeating-linear-gradient(180deg, #DC2626 0%, #DC2626 13%, #F8FAFC 13%, #F8FAFC 24%)",
          ].join(", "),
          backgroundSize: "0.085em 0.085em, 48% 52%, 100% 100%",
          backgroundRepeat: "repeat, no-repeat, no-repeat",
          backgroundPosition: "0.015em 0.015em, top left, top left",
        }}
      >
        T
      </span>
      {/* E — CATE: orange fur gradient + whiskers */}
      <span className={`${letterBase} bg-gradient-to-b from-[#F6C85F] to-[#F97316] bg-clip-text text-transparent ${lift}`}>
        <Whiskers />
        E
      </span>
    </span>
  );
}

export default function GiantTate() {
  return (
    <motion.button
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1, delay: 0.15 }}
      onClick={() => scrollToId("#top")}
      className="group mt-16 block w-full cursor-pointer text-center text-[clamp(4rem,17vw,15rem)]"
      data-testid="footer-giant-tate"
      aria-label="$TATE — back to top"
    >
      <TateLetters hoverLift />
    </motion.button>
  );
}
